import { render } from "./AddPreingestionTemplate.vue?vue&type=template&id=0b5deac0&scoped=true"
import script from "./AddPreingestionTemplate.vue?vue&type=script&lang=js"
export * from "./AddPreingestionTemplate.vue?vue&type=script&lang=js"

import "./AddPreingestionTemplate.vue?vue&type=style&index=0&id=0b5deac0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b5deac0"]])

export default __exports__